import request from '@/utils/request'

//平台服务费订单发起收银宝统一主扫支付
export const createPlatformServiceOrderData = (data) => {
    return request.get('/api/bid/order/platformServiceOrder/nativeUnifiedPay', data)
}
// 支付完成主动调取接口确认订单支付状态
export const getPlatformServiceOrderData = (data) => {
    return request.get('/api/bid/order/platformServiceOrder/confirmPayment', data)
}
